import React from 'react';

import '../../styles/common/grid-header.scss';

const GridHeader = (props) => (
    <div className="grid-header">
        <span className="title">
            <span className="label">{props.title}</span>
        </span>
        {props.subtitle && (
            <span className="subtitle">
                {props.subtitle}
            </span>
        )}
    </div>
);

export default GridHeader;